import { render, staticRenderFns } from "./DeleteTemplateForm.vue?vue&type=template&id=6ff7da16&"
import script from "./DeleteTemplateForm.vue?vue&type=script&lang=js&"
export * from "./DeleteTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports